function setDate(date = new Date()) {
  const time = date.getTime();
  const timezoneOffset = date.getTimezoneOffset() * 60000;
  let d = new Date(time - timezoneOffset);
  d = d.toISOString();
  return d.slice(0, 10) + "T" + d.slice(11, 16);
}

export default class Meeting {
  constructor(meeting = {}) {
    this.meeting_id = meeting.meeting_id || 0;
    this.meeting_link = meeting.meeting_link || "";
    this.meeting_start_date = meeting.meeting_start_date ? setDate(new Date(meeting.meeting_start_date)) : setDate();
    this.meeting_duration = meeting.meeting_end_date ? (new Date(meeting.meeting_end_date).getTime() - new Date(meeting.meeting_start_date).getTime()) / 60000 : 15;
    this.lesson_id = meeting.lesson_id || 0;
  }
}



// WEBPACK FOOTER //
// ./src/models/meeting.model.js